import type { FunctionComponent } from 'react'

import { SsoType } from '@app-types/sso'
import { SSOButton } from '@components/sso-button'
import type { FormProps } from '@contentful-components/forms/props'

export const ChooseSSO: FunctionComponent<
    React.PropsWithChildren<FormProps<Values>>
> = ({ next }) => (
    <>
        <SSOButton type={SsoType.Apple} next={next} />
        {/* <SSOButton type={SsoType.Google} /> */}
        <SSOButton type={SsoType.Email} next={next} />
    </>
)

type Values = {
    // TODO (@cataline)
}
